import { render, staticRenderFns } from "./MontlySaleReport.vue?vue&type=template&id=6680c207"
import script from "./MontlySaleReport.vue?vue&type=script&lang=js"
export * from "./MontlySaleReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports